import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";

// On-boarding steps
import OnBoardingStep1 from "./OnBoardingStep1/OnBoardingStep1";
import OnBoardingStep2 from "./OnBoardingStep2/OnBoardingStep2";
import OnBoardingStep3 from "./OnBoardingStep3/OnBoardingStep3";

// External components
import Header from "@/components/header/header";
import OnBoardingStepsCounter from "@/components/stepsCounter/onBoardingStepsCounter";

@Component({
  components: {
    OnBoardingStep1,
    OnBoardingStep2,
    OnBoardingStep3,
    Header,
    OnBoardingStepsCounter,
  },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      const { status } = vm.getSubscription;
      if (status !== "pending") {
        next({ name: "subscriptionDashboard" });
      } else {
        next();
      }
    });
  },
})
export default class OnBoarding extends Vue {
  @Getter getSubscription;
  @Getter getIsUnderMobile;

  currentStep = null;
  isGoingToNextStep = false;

  steps = [
    { step: 1, name: "Confirmar menú" },
    { step: 2, name: "Envío y pago" },
    { step: 3, name: "Comenzar plan" },
  ];

  get getMainButtonLabel() {
    const { step } = this.currentStep;
    if (step === 1) return "Confirmar menú";
    if (step === 2) return "Continuar";
    if (step === 3) return "Comenzar plan";
  }

  mounted() {
    this.currentStep = this.steps[0];
  }

  setStep(step) {
    if (step === 1) {
      this.currentStep = this.steps[0];
    } else if (step === 2) {
      this.currentStep = this.steps[1];
    }
    document.getElementById("subscriptionBase").scroll({ top: 0, left: 0, behavior: "smooth" });
  }

  goToNextStep() {
    const { step } = this.currentStep;
    switch (step) {
      case 1:
        this.currentStep = this.steps[1];
        break;
      case 2:
        this.currentStep = this.steps[2];
        break;
    }
    document.getElementById("subscriptionBase").scroll({ top: 0, left: 0, behavior: "smooth" });
  }

  goToLastStep() {
    const { step } = this.currentStep;
    if (step === 2) this.currentStep = this.steps[0];
  }
}
